import { render, staticRenderFns } from "./SwitchSolicitarTelefoneAssinatura.vue?vue&type=template&id=5096c06c&scoped=true"
import script from "./SwitchSolicitarTelefoneAssinatura.vue?vue&type=script&lang=js"
export * from "./SwitchSolicitarTelefoneAssinatura.vue?vue&type=script&lang=js"
import style0 from "./SwitchSolicitarTelefoneAssinatura.vue?vue&type=style&index=0&id=5096c06c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5096c06c",
  null
  
)

export default component.exports